import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.to ? `https://www.bajiemovie.com${item.to}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-foreground-400 py-3 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-300"></i>
            )}
            {item.to && index < items.length - 1 ? (
              <Link
                to={item.to}
                className="hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-700 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}